/**
 * DataQualityCard — Datenqualitäts-Kachel (Jun-2026, User-Wunsch).
 *
 * Zeigt offene Pflegeaufgaben aus den „Fehlende Daten"-Filtern des Fahrzeug-Tabs
 * (ohne FIN · ohne Kennzeichen · ohne Standort · ohne Preis) und springt per Klick
 * direkt in die vorgefilterte Fahrzeugliste. Quelle: facets aus GET /dealer/vehicles.
 */
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { ClipboardCheck, FileWarning, ChevronRight } from "lucide-react";
import api from "../../lib/api";

const TILES = [
    { key: "vin", label: "ohne FIN" },
    { key: "license_plate", label: "ohne Kennzeichen" },
    { key: "site_code", label: "ohne Standort" },
    { key: "price", label: "ohne Preis (Bestand)" },
];

export default function DataQualityCard() {
    const navigate = useNavigate();
    const [missing, setMissing] = useState(null);

    useEffect(() => {
        let alive = true;
        api.get("/dealer/vehicles", { params: { limit: 1 } })
            .then(({ data }) => { if (alive) setMissing(data?.facets?.missing || {}); })
            .catch(() => { if (alive) setMissing({}); });
        return () => { alive = false; };
    }, []);

    if (!missing) return null;
    const totalOpen = TILES.reduce((s, t) => s + (missing[t.key] || 0), 0);

    return (
        <div className="bg-white border border-gray-200 rounded-sm p-4" data-testid="data-quality-card">
            <div className="flex items-center justify-between mb-3">
                <h3 className="font-bold text-sm flex items-center gap-2">
                    <ClipboardCheck className="w-4 h-4 text-[#7C3AED]" /> Datenqualität — offene Pflegeaufgaben
                </h3>
                {totalOpen === 0 && (
                    <span className="text-[11px] font-bold text-emerald-600" data-testid="data-quality-clean">Alles gepflegt ✓</span>
                )}
            </div>
            <div className="grid grid-cols-2 md:grid-cols-4 gap-2">
                {TILES.map((t) => {
                    const n = missing[t.key] || 0;
                    return (
                        <button key={t.key} type="button"
                            onClick={() => navigate(`/dealer/invoices?tab=vehicles&missing=${t.key}`)}
                            className={`text-left border rounded-sm p-3 transition-colors group ${n > 0 ? "border-amber-300 bg-amber-50 hover:bg-amber-100" : "border-gray-200 hover:border-gray-300"}`}
                            data-testid={`data-quality-${t.key}`}>
                            <div className="flex items-center justify-between">
                                <FileWarning className={`w-4 h-4 ${n > 0 ? "text-amber-600" : "text-gray-300"}`} />
                                <ChevronRight className="w-3.5 h-3.5 text-gray-300 group-hover:text-gray-500" />
                            </div>
                            <div className={`mt-1 font-display font-black text-2xl ${n > 0 ? "text-amber-700" : "text-gray-400"}`} data-testid={`data-quality-count-${t.key}`}>
                                {Number(n).toLocaleString("de-DE")}
                            </div>
                            <div className="text-[11px] text-gray-500">{t.label}</div>
                        </button>
                    );
                })}
            </div>
        </div>
    );
}
